"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsCollector = void 0;
var analytics_1 = require("./analytics");
var version_1 = require("./version");
var AnalyticsCollector = /** @class */ (function () {
    function AnalyticsCollector(settings, user) {
        this.VERSION = version_1.version;
        this._analytics = new analytics_1.Analytics(settings, user);
    }
    AnalyticsCollector.prototype.track = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._analytics).track.apply(_a, __spreadArray([], __read(args), false));
    };
    AnalyticsCollector.prototype.page = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._analytics).page.apply(_a, __spreadArray([], __read(args), false));
    };
    AnalyticsCollector.prototype.identify = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._analytics).identify.apply(_a, __spreadArray([], __read(args), false));
    };
    AnalyticsCollector.prototype.user = function () {
        throw new Error('Method not implemented.');
    };
    /**
     * Instantiates an object exposing Analytics methods.
     *
     * ```ts
     * const analytics = AnalyticsCollector.create({ apiKey: '<YOUR_WRITE_KEY>' })
     *
     * analytics.track("Current Event")
     * ...
     * ```
     */
    AnalyticsCollector.create = function (settings, user) {
        if (!AnalyticsCollector._instance) {
            AnalyticsCollector._instance = new AnalyticsCollector(settings, user);
        }
        return AnalyticsCollector._instance;
    };
    return AnalyticsCollector;
}());
exports.AnalyticsCollector = AnalyticsCollector;
//# sourceMappingURL=collector.js.map